import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';

export default (t: TFunction): BaseSchema =>
  Yup.object().shape({
    privilegeCode: Yup.string().required(t('PRIVILEGE_CODE_ERROR')),
  });
